import React from 'react'
import Grid from '@material-ui/core/Grid'

const styles = {
    departmens: {
        display: 'inline-block',
        margin: '0 10px'
    },
    root: {
        border: '1px solid #eaeaea',
        padding: '10px 10px',
    }
}

export default function Departamentos() {
    return (
        <Grid style={styles.root} container>

        </Grid>
    )
}
